import React from 'react';
import { photos } from '../data/site';
export function GiftCard() {
  return <section id="carte-cadeau" aria-labelledby="cadeau-title" className="bg-sage text-white" data-id="element-22" data-mp="h6oe1q9mk29p">
      <div className="mx-auto grid max-w-7xl lg:grid-cols-2" data-id="element-23" data-mp="cfzhvxn02h48">
        <div className="px-5 py-16 lg:px-8 lg:py-24 lg:pr-16" data-id="element-24" data-mp="ceele2h4ko3q">
          <h2 id="cadeau-title" className="font-serif text-4xl font-medium leading-tight lg:text-5xl" data-id="element-25" data-mp="7ho8fo0ma8mj">
            Offrez une parenthèse d’exception
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-white/85" data-id="element-26" data-mp="2ffh0w3e7emj">
            Une carte cadeau valable sur l’ensemble de nos soins et forfaits, envoyée par e-mail ou à imprimer.
          </p>
          <div className="mt-8 flex flex-wrap gap-3" data-id="element-27" data-mp="3knemebsoirek">
            <a href="https://commeuncharme.fr/carte-cadeau" className="whitespace-nowrap rounded-full bg-white px-7 py-3.5 font-bold text-ink transition-colors duration-150 hover:bg-cream" data-id="element-28" data-mp="3kozfry39c4au">
              Offrir une carte cadeau
            </a>
            <a href="https://commeuncharme.fr/forfaits" className="whitespace-nowrap rounded-full border border-white/40 px-7 py-3.5 font-bold text-white transition-colors duration-150 hover:border-white" data-id="element-29" data-mp="3cvv4of07ycq8">
              Voir nos forfaits
            </a>
          </div>
        </div>
        <img src={photos.repos} alt="" className="h-64 w-full object-cover sm:h-80 lg:h-full" data-id="element-30" data-mp="38vl27cbmy4g4" />
      </div>
    </section>;
}